import React from "react";

import { useRecordContext } from "react-admin";

import { ServiceTemplate } from "../types";

const ServiceTemplateTitle = () => {
  const record = useRecordContext<ServiceTemplate>();
  return <span>Service-Vorlage {record ? `"${record.name}"` : ""}</span>;
};
export default ServiceTemplateTitle;
